module.exports = __webpack_public_path__ + "assets/img/Twitter.616be22c.svg";